import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { AuthenicationService } from '../../_services/authenication.service';
import { ContactusService } from '../../_services/contactus.service';
import {environment} from "../../../environments/environment";
import { ToasterService } from '../../_services/toaster.service';
import { DoctorService } from '../../_services/doctor.service';
import {ExcelServicesService} from "../../_services/excel-services.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
declare var $: any;

@Component({
  selector: 'app-get-review',
  templateUrl: './get-review.component.html',
  styleUrls: ['./get-review.component.css']
})
export class GetReviewComponent implements OnInit {

  userdetaild: string;
  baseUrl: string = environment.baseUrl;
  returnUrl: string;
  contactlist: any;
  contactlist1: any;
  averageRating: number = 0;
  id: string = this.route.snapshot.params.id;
  patients_data: any[] = [];
  questions: any[] = [];
  answers: any[] = [];

  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private contactusservice: ContactusService, private toaster: ToasterService, private doctorservice: DoctorService,private excelService:ExcelServicesService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
    const payload = {
          docid: this.id,
          userType: "internal"
    };
    this.getDoctorReview(payload);
    this.getAppointmentFeedback(payload);
  }
  exportAsXLSX():void {
    this.spinnerService.show();
    this.excelService.exportAsExcelFile(this.patients_data, 'review_list');
    this.spinnerService.hide();
  }

  getDoctorReview(payload) {
    this.contactusservice.getDoctorReview(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.contactlist = data.quoteList;


            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          } else {
            // this.toaster.showError('Doctor', data.ResponseMessage);
            setTimeout( () => {
              $(function () {
                $('#example').DataTable();
              });
            }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          // this.toaster.showError('Doctor', error.error.ResponseMessage);
          setTimeout( () => {
            $(function () {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }

  getAppointmentFeedback(payload) {
    this.doctorservice.getAppointmentFeedback(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.contactlist1 = data.Data;
            this.questions = data.Data['questions'];
            this.answers = data.Data['feedback'];
            this.contactlist= data.Data["docs"];
            this.averageRating = data.Data['feedback'].length;

            
           
            setTimeout(()=>{
              $(function() {
                $('#example1').DataTable();
              });
            }, 1000);
          } else {
            // this.toaster.showError('Doctor', data.ResponseMessage);
            setTimeout( () => {
              $(function () {
                $('#example1').DataTable();
              });
            }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          // this.toaster.showError('Doctor', error.ResponseMessage);
          setTimeout( () => {
            $(function () {
              $('#example1').DataTable();
            });
          }, 1000);
        });
  }


  showOnWebsite(status, id) {

    const formdata = {
      status: status,
      id: id,
    };

    this.doctorservice.updateAppointmentFeedback(formdata)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.toaster.showSuccess('Status Changed', data.ResponseMessage);
            this.reloadComponent();
          } else {
            this.toaster.showError('Status Changed', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Status Changed', error.ResponseMessage);
        });
  }

  reloadComponent() {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([`/get-review/${this.id}`]);
  }

}
